import {
  getModule,
  Module,
  MutationAction,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import * as FollowAPI from "@/api/analysis/follow";
import { isSuccess } from "@/api/response";
import { FollowGetRequest } from "@/api/analysis/follow/request";
import { FollowGetResponse } from "@/api/analysis/follow/response";

const MODULE_NAME = "analysis/analysis-follow/get";

/**
 *  フォローAPI（/analysis-analysis-follow）のレスポンスを管理するストアモジュール
 */
@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class Get extends VuexModule {
  // state
  getRequest: FollowGetRequest = {} as FollowGetRequest;
  getResponse: FollowGetResponse = {} as FollowGetResponse;

  // getters
  get isSuccess() {
    return isSuccess(this.getResponse);
  }

  get getMessage() {
    return this.getResponse.message;
  }

  get getData() {
    if (this.getResponse.results) {
      return this.getResponse.results.data || null;
    } else {
      return [];
    }
  }

  get getDate() {
    if (this.getResponse.results) {
      return this.getResponse.results.date || '';
    } else {
      return '';
    }
  }

  get getTotalCount() {
    if (this.getResponse.results) {
      return this.getResponse.results.totalCount || 0;
    } else {
      return 0;
    }
  }

  get getGetRequest() {
    return this.getRequest;
  }
  // MutationActions
  @MutationAction
  async get(getRequest: FollowGetRequest) {
    const getResponse = await FollowAPI.get(getRequest);
    return {
      getResponse
    };
  }

  @MutationAction
  async clearResponse() {
    return {
      getResponse: {} as FollowGetResponse
    };
  }
}

export default getModule(Get);
